import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";

import { CloseIcon } from "../../../components/Icons";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { PAGES_PATH } from "../../../navigation/params";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { WellnessSuccessAvatar } from "../../../components";
import { dateToString } from "../../../utils/unix-timestamp";
import { useModal } from "../../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { userActivityLogger } from "../../../utils/mixpanel";

interface IScratchPaySuccessModalProps {
  petId: string;
  petName: string;
  petImage?: string;
  planName: string;
}

const ScratchPaySuccessModal = () => {
  const navigate = useNavigate();
  const { closeModal, params } = useModal();

  const {
    petId,
    petName,
    petImage,
    planName,
  } = params as unknown as IScratchPaySuccessModalProps;
  const formattedStartDate = dateToString(new Date());

  const handleDismiss = () => {
    userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_SUCCESS_MODAL_DISMISSED, {
      pet_id: petId,
      pet_name: petName,
      plan_name: planName,
      payment_method: "ScratchPay",
      dismiss_source: "x",
    });

    closeModal();
    navigate(`${PAGES_PATH.PET_CARE}?id=${petId}&category=TotalCare_Plan`);
  };

  const handleExplorePlan = () => {
    userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_SUCCESS_EXPLORE_PLAN_CLICKED, {
      pet_id: petId,
      pet_name: petName,
      plan_name: planName,
      payment_method: "ScratchPay",
    });

    closeModal();
    navigate(`${PAGES_PATH.PET_CARE}?id=${petId}&category=TotalCare_Plan`);
  };

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_PURCHASE_SUCCESS_MODAL_VIEWED, {
      pet_id: petId,
      pet_name: petName,
      plan_name: planName,
      payment_method: "ScratchPay",
    });
  }, []);

  return (
    <Box className="bg-white flex flex-col justify-center items-center gap-5 w-full rounded-3xl">
      <Box className="flex justify-end w-full relative -top-3 -right-2">
        <Box
          className="bg-gray-6 rounded-full p-1 cursor-pointer"
          onClick={handleDismiss}
        >
          <CloseIcon className="text-light-black" />
        </Box>
      </Box>

      <WellnessSuccessAvatar image={petImage || ""} name={petName} />

      <Typography
        textAlign="center"
        variant="h2"
        className="!font-semibold !text-[30px] !leading-[32px] grenette-pro"
      >
        Woohoo! <span className="capitalize">{petName}</span> is on the{" "}
        <br />
        {planName}
      </Typography>

      <Box className="flex flex-col gap-4 w-full">
        <Box className="bg-gray-2 p-2 flex justify-center items-center rounded">
          <Typography
            textAlign="center"
            className="!text-base !leading-6 text-light-black"
          >
            We&apos;ve sent you a confirmation email
          </Typography>
        </Box>

        <Typography
          textAlign="center"
          className="!text-base !leading-6 !w-full text-light-black"
        >
          <span className="capitalize">{petName}</span>&apos;s plan starts{" "}
          {formattedStartDate}
        </Typography>
      </Box>

      <StyledBookingFlowButton
        fullWidth
        color="primary"
        size="small"
        className="!mt-2"
        onClick={handleExplorePlan}
      >
        Explore Plan
      </StyledBookingFlowButton>
    </Box>
  );
};

export default ScratchPaySuccessModal;

